import { render } from "./AppLabelPrintSelect.vue?vue&type=template&id=f1b534f4"
import script from "./AppLabelPrintSelect.vue?vue&type=script&lang=js"
export * from "./AppLabelPrintSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__